import { useUser } from "@/contexts/UserContext";
import { useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

const HomeRedirect: React.FC = () => {
  const { isManager, isApprover, isAdmin, isLoading } = useUser();
  const navigate = useNavigate();
  useEffect(() => {
    if (isLoading) return;
    if (isManager) navigate({ to: "/manager/instructions/statistics" });
    else if (isApprover) navigate({ to: "/approver/instructions/statistics" });
    else if (isAdmin || isApprover) navigate({ to: "/admin" });
    else navigate({ to: "/error/401" });
  }, [isLoading, isManager, isApprover, isAdmin, navigate]);
  return null;
};

export default HomeRedirect;
